import { fetchHTML } from './utils-fetch-html.js';

class CollectionGrid extends HTMLElement {
  abortController;

  connectedCallback() {
    this.unsubscribeSortChanged = subscribe('sort:changed', () => this.handleSortChange());
    this.unsubscribeFiltersUpdated = subscribe('filters:updated', () => this.handleSortChange());

    this.setupClearMachineButton();
  }

  disconnectedCallback() {
    this.unsubscribeSortChanged();
    this.unsubscribeFiltersUpdated();
  }

  /**
   * Handle sort change
   */
  async handleSortChange() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const searchParams = new URLSearchParams(window.location.search);

    try {
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=main-collection&${searchParams}`
      );

      this.renderProductGrid(html);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Render product grid
   * @param {HTMLElement} html - HTML to render
   */
  renderProductGrid(html) {
    const parsedCollectionGrid = html.querySelector('collection-grid');

    this.innerHTML = parsedCollectionGrid.innerHTML;
  }

  setupClearMachineButton() {
    const clearButton = document.getElementById('clear-machine-selection');
    if (!clearButton) return;
    clearButton.addEventListener('click', () => {
      window.getMachineController().clearFilters();
      const url = new URL(window.location.href);
      url.search = '';
      window.location.href = url.toString();
    });
  }
}

customElements.define('collection-grid', CollectionGrid);
